import React from "react";

// Distinctive eebssolutions chevron logo
export const LogoMark = ({ className = "", color = "#2D6A4F" }) => (
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Top parallelogram (pointing left) */}
    <path d="M46 6 L22 6 L6 26 L30 26 Z" fill={color} />
    {/* Bottom parallelogram (pointing left, offset) */}
    <path d="M54 32 L30 32 L14 54 L38 54 Z" fill={color} />
  </svg>
);

const Logo = ({ white = false }) => {
  const color = white ? "#FFFFFF" : "#2D6A4F";
  const textColor = white ? "text-white" : "text-[#0E0E10]";
  return (
    <div className="flex items-center gap-2 select-none">
      <LogoMark className="w-8 h-8 -rotate-6" color={color} />
      <span
        className={`text-[18px] tracking-tight font-extrabold ${textColor}`}
        style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
      >
        eebssolutions
      </span>
    </div>
  );
};

export default Logo;
